import {useContext} from 'react';
import {UserContext} from 'store/User';

function useUser() {
    return useContext(UserContext);
}

export default useUser;
